import httpClient from '../httpClient';

const getAllByValidation = async (id) => {
  return await httpClient.get(
    `/term_legal_validation_document_history/?filter[contrato_proceso]=${id}`,
  );
};

export { getAllByValidation };
